import { useEffect, useState } from "react";
import { Trophy } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export default function Gradebook() {
  const [grades, setGrades] = useState([]);
  useEffect(() => { api.get("/grades").then((r) => setGrades(r.data)); }, []);

  const notes20 = grades.map((g) => (g.max ? (g.grade / g.max) * 20 : 0));
  const avg = notes20.length ? (notes20.reduce((a, b) => a + b, 0) / notes20.length).toFixed(2) : "0";

  return (
    <div className="space-y-6" data-testid="gradebook-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">Évaluations</p>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Carnet de notes</h1>
      </div>

      <div className="flex items-center gap-4 rounded-xl border border-border bg-primary p-6 text-primary-foreground">
        <Trophy size={40} weight="duotone" />
        <div>
          <p className="text-sm opacity-90">Moyenne générale (sur 20)</p>
          <p className="font-display text-4xl font-extrabold">{avg}</p>
        </div>
      </div>

      <div className="rounded-xl border border-border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Type</TableHead>
              <TableHead>Intitulé</TableHead>
              <TableHead>Cours</TableHead>
              <TableHead className="text-right">Note</TableHead>
              <TableHead>Commentaire</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {grades.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="py-10 text-center text-muted-foreground">Aucune note pour l'instant.</TableCell></TableRow>
            ) : grades.map((g, i) => (
              <TableRow key={i}>
                <TableCell><Badge variant="secondary">{g.type}</Badge></TableCell>
                <TableCell className="font-medium">{g.title}</TableCell>
                <TableCell className="text-muted-foreground">{g.course || "—"}</TableCell>
                <TableCell className="text-right font-display font-bold text-primary">{g.grade}/{g.max}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{g.feedback || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
